import React from "react";
import { connect } from "react-redux";
import $ from "jquery";
import CommonIcon from "../../helpers/icons";
import moment from "moment";
import Chart from "react-apexcharts";
import Loader from "../../helpers/loader";
import UserRole from "../../helpers/role";
import Toaster from "../../helpers/toaster";
import { Navigate } from "react-router";
import API from "../../helpers/endpointservice";
import axios from "axios";
import { colors } from "../../helpers/Constants";
import { logoutFunction } from "../../custom/logoutFunction";
import swal from "sweetalert";
import CommonFilterModal from "../common/commonFilterModal";
import InfoIcon from '@mui/icons-material/Info';

var isSorting = false;

class home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      sortBy: "courseCode",
      developmentorder: "asc",
      developmentsortBy: "jobGroup",
      options: {
        dataLabels: {
          enabled: true,
          formatter: function (val, option) {
            if (option?.w?.globals?.initialSeries?.length == 6) {
            } else {
              return val.toFixed(2) + "%"
            }
          },
        },
        legend: false,
        labels: ["Master", "Competent", "Learning", "Novice", 'NA', "No records"],
        // labels: [],
        colors: [colors.GREEN, colors.BLUE, colors.ORANGE, colors.YELLOW, colors.BROWN, colors.GREY],
        stroke: {
          width: 0
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
          }
        },
      },
      skills: [
        {
          value: 1,
          label: "Leanne Graham",
        },
        {
          value: 2,
          label: "Ervin Howell",
        },
      ],
      series: [],
      isMobile: false,
      isMobile450: false,
      isMobile350: false,
      isMobile650: false,
      isMobile900: false,
      isMobilechat: false,
      isSkillmatrix: false,
      isPendinigTask: false,
      isHomeLoader: false,
      isMyTrainings: false,
      isMyDirectReport: false,
      isUpcomingTraining: false,
      isChatResponsive: false,
      isMyTrainingRequests: false,
      isPieChart: false,
      userId: 0,
      height: 0,
      width: 0,
      currentUser: "",
      supportingRolesList: [],
      graphDataValue: false,
      viewTrainingDetails: "",
      pendingTaskCount: 0,
      traningsRequestCount: 0,
      traningRecordsCount: 0,
      directReportsCount: 0,
      currentPage: 1,
      perPage: 5,
      upcomingtrainingList: [],
      isDevelopmentPlan: false
    };
  }
  componentDidMount() {
    this.setState({ isHomeLoader: true })
    const userId = localStorage.getItem("UserId");
    const userRole = localStorage.getItem("Role").split(",")[0];
    this.state.userId = userId;
    this.state.currentUser = userRole;
    // this.state.currentUser = "employee";
    this.setState({}, () => {
      this.getUpcomingTrainingList();
      this.getSkillOverview();
      this.getPendingTaskCount();
      this.getDevelopmentPlanList();
      // if (UserRole.SUPERVISOR == this.state.currentUser || UserRole.MANAGER == this.state.currentUser || UserRole.GM == this.state.currentUser) {
      //   this.getDirectReportsCount();
      // }
    })
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    $("body").removeClass("scrollhide");
  }
  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }

    if (window.innerWidth < 900) {
      this.state.isMobile900 = true;
    } else {
      this.state.isMobile900 = false;
    }

    if (window.innerWidth < 350) {
      this.state.isMobile350 = true;
    } else {
      this.state.isMobile350 = false;
    }

    if (window.innerWidth < 650) {
      this.state.isMobile650 = true;
    } else {
      this.state.isMobile650 = false;
    }

    if (window.innerWidth < 450) {
      this.state.isMobile450 = true;
    } else {
      this.state.isMobile450 = false;
    }
    // if (window.innerWidth > 1510) {
    //   this.state.isMobilechat = true;
    // } else {
    //   this.state.isMobilechat = false;
    // }
    if (window.innerWidth > 1700) {
      this.state.isChatResponsive = true;
    } else {
      this.state.isChatResponsive = false;
    }

    this.state.height = window.innerHeight;
    this.state.width = window.innerWidth;
    this.setState({});
  };

  getSkillOverview = () => {
    this.state.options.labels = [];
    this.state.options.colors = [];
    this.state.series = [];
    this.setState({})
    let apiUrl = `${API.GET_SKILL_OVERVIEW_MATRIX}?userId=${this.state.userId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.master > 0 || res.data.competent > 0 || res.data.novice > 0 || res.data.na > 0 || res.data.learning > 0) {
            let color = Object.keys(res.data);
            color.map((item, index) => {
              if (item == "master") {
                this.state.options.labels.push('Master')
                this.state.options.colors.push('#28A745')
                this.state.series.push(
                  {
                    "label": res.data.master,
                    "description": res.data.masterProficiencyDescription
                  }
                )
                this.setState({});
              } else if (item == "competent") {
                this.state.options.labels.push("Competent")
                this.state.options.colors.push('#508FD6')
                this.state.series.push(
                  {
                    "label": res.data.competent,
                    "description": res.data.competentProficiencyDescription
                  }
                )
                this.setState({});
              } else if (item == "learning") {
                this.state.options.labels.push("Learner")
                this.state.options.colors.push('#EC930D')
                this.state.series.push(
                  {
                    "label": res.data.learning,
                    "description": res.data.learningProficiencyDescription
                  }
                )
                this.setState({});
              } else if (item == "novice") {
                this.state.options.labels.push("Novice")
                this.state.options.colors.push('#EAD51A')
                this.state.series.push(
                  {
                    "label": res.data.novice,
                    "description": res.data.noviceProficiencyDescription
                  }
                )
                this.setState({});
              } 
              // else if (item == "na") {
              //   this.state.options.labels.push("NA")
              //   this.state.options.colors.push("#A52A2A")
              //   this.state.series.push(
              //     {
              //       "label": res.data.na,
              //       "description": res.data.naProficiencyDescription
              //     }
              //   )
              // }
              this.setState({ isPieChart: true, graphDataValue: true })
            }
            )
          }
          else {
            this.state.options.labels.push("No records")
            this.state.options.colors.push("#808080")
            // this.state.series.push()
            this.setState({ graphDataValue: false, isPieChart: true })
          }
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isHomeLoader: false })
        console.log(error);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      })
  };
  getUpcomingTrainingList = () => {
    let order = this.state.order === 'asc' ? true : false;
    let apiUrl = `${API.GET_UPCOMING_TRAINING_HOME}?userId=${this.state.userId}&sortBy=${this.state.sortBy}&isSortAscending=${order}&pageNumber=${this.state.currentPage}&pageSize=${this.state.perPage}`;;
    axios({
      method: "POST",
      url: apiUrl,
      data: {}
    }).then((res) => {
      this.state.upcomingtrainingList = res.data.values;
      if (isSorting === true) {
        this.state.isHomeLoader = false;
      }
      this.setState({}, () => {
        // if (isSorting === false) {
        //   this.getPendingTaskCount();
        // }
        isSorting = false;
      });
    })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isHomeLoader: false })
        console.log(error);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      }
      );
  };
  getPendingTaskCount = () => {
    let apiUrl = `${API.GET_ALL_PENDING_TASK_COUNT}?userId=${this.state.userId}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.pendingTaskCount = res.data.pendingTaskCount;
        this.state.traningRecordsCount = res.data.trainingRecordsCount;
        this.state.traningsRequestCount = res.data.trainingRequestCount;
        this.state.directReportsCount = res.data?.trainingAssignedCount ?? res.data.trainingAssignedCount;
        // this.setState({}, () => {
        //   this.getTraningRecordsCount()
        // });
      }
    })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isHomeLoader: false });
        console.log(error);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      }
      );
  }

  // getTraningRecordsCount = () => {
  //   let apiUrl = `${API.GET_TRAINING_RECORDS_COUNT}`;
  //   axios({
  //     method: "GET",
  //     url: apiUrl,
  //   }).then((res) => {
  //     if (res.status === 200) {
  //       this.state.traningRecordsCount = res.data
  //       this.setState({}, () => {
  //         this.getCompletedTaskCount()
  //       });
  //     }
  //   })
  //     .catch((error) => {
  //       logoutFunction(error?.response?.status);
  //     }
  //     );
  // }

  // getCompletedTaskCount = () => {
  //   let apiUrl = `${API.GET_TRAINING_REQUEST_COUNT}?userId=${this.state.userId}`;
  //   axios({
  //     method: "GET",
  //     url: apiUrl,
  //   }).then((res) => {
  //     if (res.status === 200) {
  //       this.state.traningsRequestCount = res.data
  //       this.setState({}, () => {
  //         this.getDirectReportsCount()
  //       });
  //     }
  //   })
  //     .catch((error) => {
  //       this.setState({ isHomeLoader: false })
  //       logoutFunction(error?.response?.status);
  //     }
  //     );
  // }

  getDirectReportsCount = () => { //DOubt
    let apiUrl = `${API.GET_TEAM_TRAINING_COUNT}?userId=${this.state.userId}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.directReportsCount = res.data
        this.setState({});
        // this.setState({}, () => {
        //   this.getDevelopmentPlanList()
        // });
      }
    })
      .catch((error) => {
        this.setState({ isHomeLoader: false });
        console.log(error);
        logoutFunction(error?.response?.status);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      }
      );
  }

  getDevelopmentPlanList = () => {
    let order = this.state.developmentorder === 'asc' ? true : false;
    let apiUrl = `${API.GET_TEAM_SKILL_CHART_BY_ID}?userId=${this.state.userId}&isDevelopmentplan=true&sortBy=${this.state.developmentsortBy}&pageNumber=${this.state.currentPage}&pageSize=${this.state.perPage}&isSortAscending=${order}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: {}
    }).then((res) => {
      if (res.status === 200) {
        this.state.supportingRolesList = res.data.values;
        this.setState({ isHomeLoader: false })
      } else {
        this.setState({ isHomeLoader: false })
      }
    }).catch((error) => {
      this.setState({ isHomeLoader: false })
      logoutFunction(error?.response?.status);
      console.log(error);
      swal("Error!", "Something went wrong. Please try again.", "warning");
    })
  }

  applyForTrainingScreen = (id) => {
    this.setState({ isHomeLoader: true })
    let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("applyfortraining"));
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    this.getTrainingDetailsById(id);

  }

  getTrainingDetailsById = (id) => {
    let apiUrl = `${API.GET_TRAININING_DETAILS_ID}?trainingId=${id}&userId=${this.state.userId}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.viewTrainingDetails = {
          id: res.data.id,
          courseCode: res.data.courseCode,
          courseTitle: res.data.courseTitle,
          courseId: res.data.courseId,
          category1Name: res.data.category1Name,
          category2Name: res.data.category2Name,
          trainingHours: res.data.trainingHours,
          skills: res.data.skills,
          vendorName: res.data.vendorName,
          courseDiscription: res.data.courseDiscription,
          trainingDiscription: res.data.trainingDiscription,
          comments: res.data.trainingDiscription,
          startDate: res.data.startDate ? moment(new Date(Date.parse(res.data.startDate))).format("DD-MMM-YYYY") : "",
          endDate: res.data.endDate ? moment(new Date(Date.parse(res.data.endDate))).format("DD-MMM-YYYY") : "",
        }

        this.setState({ isHomeLoader: false });
      }
    })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isHomeLoader: false })
        console.log(error);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      }
      );
  }

  sortTable = (name) => {
    isSorting = true;
    let sortData = this.state.upcomingtrainingList;
    if (sortData.length !== 0) {
      this.setState({ isHomeLoader: true })
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc"
          this.state.order = ordernew;
        }
        else {
          var ordernew = "asc"
          this.state.order = ordernew;
        }
      }
      else {
        this.state.sortBy = name;
        this.state.order = 'asc'
      }
      this.state.currentPage = 1;
      this.setState({}, () => {
        this.getUpcomingTrainingList()
      })
    }
  };

  sortTable1 = (name) => {
    let sortData = this.state.supportingRolesList;
    if (sortData.length !== 0) {
      this.setState({ isHomeLoader: true })
      if (this.state.developmentsortBy === name) {
        this.state.developmentsortBy = name;
        if (this.state.developmentorder === "asc") {
          var ordernew = "desc"
          this.state.developmentorder = ordernew;
        }
        else {
          var ordernew = "asc"
          this.state.developmentorder = ordernew;
        }
      }
      else {
        this.state.developmentsortBy = name;
        this.state.developmentorder = 'asc'
      }
      this.state.currentPage = 1;
      this.setState({}, () => {
        this.getDevelopmentPlanList()
      })
    }
  };

  closeProperties = () => {
    $("#applyfortraining").removeClass("show");
    $("body").removeClass("scrollhide")
    this.getUpcomingTrainingList()
  };

  render() {
    const { sortBy, order, isMobilechat, supportingRolesList, isBigMobile, isChatResponsive, isMyTrainingRequests, isHomeLoader, upcomingtrainingList, developmentorder, developmentsortBy, width, isMobile, isUpcomingTraining, isMyDirectReport, isMyTrainings, isPendinigTask, isSkillmatrix, isMobile450, isDevelopmentPlan } = this.state;
    let { menuToggle } = this.props;
    return (
      <>
        <Toaster />
        {$("#applyfortraining").hasClass("show") ? <div className='viewbar-overlay' ></div> : <></>}
        {isSkillmatrix &&
          <Navigate to="/skillmatrix" replace={true} />
        }
        {isPendinigTask &&
          <Navigate to="/mypendingtask" replace={true} />
        }
        {isMyTrainings &&
          <Navigate to="/trainingrecord" replace={true} />
        }
        {isMyTrainingRequests &&
          <Navigate to="/requeststatus" replace={true} />
        }
        {isMyDirectReport &&
          <Navigate to="/teamstrainings" replace={true} />
        }
        {isUpcomingTraining &&
          <Navigate to="/upcomingtrainings" replace={true} />
        }
        {isDevelopmentPlan &&
          <Navigate to="/skillmatrix" replace={true} />
        }

        <div className={`${isMobile ? "main-body-mobile" : menuToggle ? "menu-main-body" : "main-body"} `}>
          <Loader isLoader={isHomeLoader} />

          <div className={` ${isMobile ? "mt-48 ml-68" : "ml-30"} mr-40 table-responsive table-responsive-scroll `}>
            <div className={`${isMobilechat ? "row" : isMobile ? "" : "display-flex"} mb-3 w-100 ml-0`}>
              <div className={` ${isBigMobile ? "col-5home-new" : isMobilechat && UserRole.EMPLOYEE == this.state.currentUser ? "col-5home-new" : isMobilechat && UserRole.EMPLOYEE !== this.state.currentUser ? "col-5home" : isMobilechat === false && UserRole.EMPLOYEE === this.state.currentUser ? "myjob-skills-div1" : isMobile ? "myjob-skills-div-w100" : "myjob-skills-div"} position-relative`}>
                <div className="ml-40 mt-3 mb-4 display-flex">
                  <div><CommonIcon fileName="myjob" /></div>
                  <div className="text-20-bold pl-10">My job skills & competency</div>
                </div>
                <div className="d-flex chart-align">
                  {this.state.isPieChart &&
                    <>
                      <div className="mt-1">
                        <Chart
                          options={this.state.options}
                          series={this.state.graphDataValue ?
                            this.state.series?.map(item => item.label)
                            : [0, 0, 0, 0, 0, 100]}
                          type="pie"
                          width="260"
                          height="250"
                        />
                      </div>
                      <div className={`${UserRole.EMPLOYEE == this.state.currentUser ? "home-overview1" : "home-overview"}`}>
                        {
                          this.state.graphDataValue ?
                            (this.state.series.map((item, index) => (
                              <div className="display-flex no-wrap mb-1"><div className="square mt-10" style={{ backgroundColor: this.state.options.colors[index] }}></div> <div className="mt-1 pl-5 min-width-legend display-flex"> {this.state.options.labels[index]}
                                <div className="tooltip">
                                  <InfoIcon className="info-icon"></InfoIcon>
                                  <span class={`${this.state.options.labels[index] == "NA" ? 'tooltip-na' : ''} tooltiptext text-12-normal`}>{item.description}</span>
                                </div>
                              </div><span className="mx-4 mt-1">{item.label + "%"}</span></div>
                            )))
                            :
                            (
                              <div className="display-flex no-wrap"><div className="square mt-10" style={{ backgroundColor: "#D3D3D3" }}></div > <div className="mt-1 mx-2 min-width-legend"> No records </div></div>)
                        }
                      </div>
                    </>}
                </div>
                <div className="position-absolute bottom-0 end-0 cursor-pointer" onClick={() => { this.setState({ isSkillmatrix: true }) }}><label className="text-10-red mx-3 mb-2 cursor-pointer"> View Details </label></div>
              </div>
              <div className={` ${isMobile ? "" : isMobilechat && UserRole.EMPLOYEE == this.state.currentUser ? "ml-45" : "ml-20"} position-relative ${isMobilechat && UserRole.EMPLOYEE == this.state.currentUser ? "col-2home-new" : isMobilechat && UserRole.EMPLOYEE !== this.state.currentUser ? "col-2home" : isMobilechat === false && UserRole.EMPLOYEE === this.state.currentUser ? "mypendingtask-div1" : isMobile ? "mypendingtask-div-w100" : "mypendingtask-div"}`}>
                <div className="mt-3 mb-4 text-center">
                  {/* <CommonIcon fileName="pendinghome" /><span className="text-16-bold pl-10">My pending tasks</span> */}
                  <CommonIcon fileName="PendingTaskHome" /><span className="text-16-bold pl-10">My pending tasks</span>
                </div>
                <div className="text-center pendingtask-number ">
                  <span className=" text-36-red">{this.state.pendingTaskCount ? this.state.pendingTaskCount : 0}</span>
                </div>
                <div className="text-center text-24">Pending tasks</div>
                <div className="position-absolute bottom-0 end-0 cursor-pointer" onClick={() => { this.setState({ isPendinigTask: true }) }}><label className="text-10-red mx-3 mb-2 cursor-pointer"> View Details </label></div>
              </div>
              {UserRole.SUPERVISOR == this.state.currentUser || UserRole.MANAGER == this.state.currentUser || UserRole.GM == this.state.currentUser ?
                <div className={` ${isMobile ? "" : isMobilechat && UserRole.EMPLOYEE == this.state.currentUser ? "ml-45" : "ml-20"} position-relative ${isMobilechat && UserRole.EMPLOYEE == this.state.currentUser ? "col-2home-new" : isMobilechat && UserRole.EMPLOYEE !== this.state.currentUser ? "col-2home" : isMobilechat === false && UserRole.EMPLOYEE === this.state.currentUser ? "mypendingtask-div1" : isMobile ? "mypendingtask-div-w100" : "mypendingtask-div"}`}>
                  <div className="mt-3 mb-4 text-center">
                    <CommonIcon fileName="pendingTraning" /><span className="text-16-bold pl-10">Direct Reports</span>
                  </div>
                  <div className="text-center pendingtask-number ">
                    <span className=" text-36-red">{this.state.directReportsCount ? this.state.directReportsCount : 0}</span>
                  </div>
                  <div className="text-center text-24 pl-10 pr-10">Trainings are assigned</div>
                  <div className="position-absolute bottom-0 end-0 cursor-pointer" onClick={() => { this.setState({ isMyDirectReport: true }) }}><label className="text-10-red mx-3 mb-2 cursor-pointer"> View Details </label></div>

                </div> : null}
              <div className={` ${isMobile ? "" : isMobilechat && UserRole.EMPLOYEE == this.state.currentUser ? "ml-45" : "ml-20"} position-relative ${isMobilechat && UserRole.EMPLOYEE == this.state.currentUser ? "col-2home-new" : isMobilechat && UserRole.EMPLOYEE !== this.state.currentUser ? "col-2home" : isMobilechat === false && UserRole.EMPLOYEE === this.state.currentUser ? "mypendingtask-div1" : isMobile ? "mypendingtask-div-w100" : "mypendingtask-div"}`}>
                <div className="mt-3 mb-4 text-center">
                  {/* <CommonIcon fileName="pendingTraining" /><span className="text-16-bold pl-10">My training requests</span> */}
                  <CommonIcon fileName="MyrequestStatusIcon" /><span className="text-16-bold pl-10">My training records</span>
                </div>
                <div className="text-center pendingtask-number ">
                  <span className=" text-36-red">{this.state.traningsRequestCount ? this.state.traningsRequestCount : 0}</span>
                </div>
                <div className="text-center text-24 pl-10 pr-10">Training requests are open</div>
                <div className="position-absolute bottom-0 end-0 cursor-pointer" onClick={() => { this.setState({ isMyTrainingRequests: true }) }}><label className="text-10-red mx-3 mb-2 cursor-pointer"> View Details </label></div>
              </div>

              {(UserRole.ADMIN === this.state.currentUser) &&
                (<div className={` ${isMobile ? "" : isMobilechat && UserRole.EMPLOYEE == this.state.currentUser ? "ml-45" : "ml-20"}  position-relative ${isMobilechat && UserRole.EMPLOYEE == this.state.currentUser ? "col-2home-new" : isMobilechat && UserRole.EMPLOYEE !== this.state.currentUser ? "col-2home" : isMobilechat === false && UserRole.EMPLOYEE === this.state.currentUser ? "mypendingtask-div1" : isMobile ? "mypendingtask-div-w100" : "mypendingtask-div"}`}>
                  <div className="mt-3 mb-4 text-center">
                    {/* <CommonIcon fileName="traningRecordsHome" /><span className="text-16-bold pl-10"> Training records</span> */}
                    <CommonIcon fileName="trainingRecords" /><span className="text-16-bold pl-10"> Training records</span>
                  </div>
                  <div className="text-center pendingtask-number ">
                    <span className=" text-36-red">{this.state.traningRecordsCount ? this.state.traningRecordsCount : 0}</span>
                  </div>
                  <div className="text-center text-24">Training records</div>
                  <div className="position-absolute bottom-0 end-0  cursor-pointer" onClick={() => { this.setState({ isMyTrainings: true }) }}><label className="text-10-red mx-3 mb-2 cursor-pointer"> View Details </label></div>
                </div>)}
            </div>
          </div>
          <div className={` ${isMobile ? 'ml-68' : 'ml-30'} mr-40 mt-2 table-responsive table-responsive-scroll`}>
            <div className="border-left w-100 tablestyle-plan  border-right">
              <div className={`px-4 ml-0 pb-20 text-20-bold pt-4 position-relative row w-100  border-top`}>
                <div className="mt-3px col-6"> <CommonIcon fileName="homeTraining" /><span className="text-20-bold pl-10">My upcoming training</span></div>
                <div className="text-16-red mt-3px col-6 text-align-end" onClick={() => { this.setState({ isUpcomingTraining: true }) }}><span className="pr-10 cursor-pointer">Company training calendar </span><CommonIcon fileName="forwardicon" /></div>
              </div>
              <div className={`table-fixed-header  ${upcomingtrainingList?.length > 4 ? "height-33vh" : "h-auto"}`}>
                <table className="table traningtable">
                  <thead>
                    <tr>
                      <td className="border-bottom-none"></td>
                      <td onClick={() => this.sortTable("courseCode")} className="cursor-pointer border-bottom-none">
                        <span> Course code </span>
                        {sortBy === "courseCode" && (<CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />)}
                      </td>
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable("courseTitle")}>
                        <span> Course title </span>
                        {sortBy === "courseTitle" && (<CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />)}
                      </td>
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable("vendor")}>
                        <span> Vendor </span>
                        {sortBy === "vendor" && (<CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />)}
                      </td>
                      {UserRole.ADMIN == this.state.currentUser && <>
                        <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable("skills")} >
                          <span> Skills </span>
                          {sortBy === "skills" && (<CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />)} </td>
                      </>}
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable("trainingHours")} >
                        <span> Training hours </span>
                        {sortBy === "trainingHours" && (
                          <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />)} </td>
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable("startDate")}>
                        <span> Start date </span>
                        {sortBy === "startDate" && (
                          <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />)}
                      </td>
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable("endDate")}>
                        <span> End date </span>
                        {sortBy === "endDate" && (
                          <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />
                        )}
                      </td>
                      <td className="width-10px border-bottom-none"></td>
                    </tr>
                  </thead>
                  <tbody>
                    {upcomingtrainingList.length !== 0 ? (
                      upcomingtrainingList.map((item, index) => (
                        <tr id={"active" + item.id} key={index} className={`${index === upcomingtrainingList.length - 1 ? "border-bottom" : ""}`}>
                          <td className="cursor-default"></td>
                          <td className="width-150px">
                            <a className="properties-view" onClick={() => { this.applyForTrainingScreen(item.id) }}>{item.courseCode}</a>
                          </td>
                          <td className="cursor-default width-150px"><span>{item.courseTitle}</span>
                          </td>
                          <td className="cursor-default width-150px"><span>{item.vendorName}</span>
                          </td>
                          {UserRole.ADMIN == this.state.currentUser && <> <td className="cursor-default"><span>{item.skills}</span> </td></>}
                          <td className="cursor-default width-150px">
                            <span>{item.trainingHours}</span>
                          </td>
                          <td>
                            <span className={` cursor-default `} >
                              {item.startDate ? moment(new Date(Date.parse(item.startDate))).format("DD-MMM-YYYY") : ""}
                            </span>
                          </td>
                          <td className="cursor-default">
                            <span>{item.endDate ? moment(new Date(Date.parse(item.endDate))).format("DD-MMM-YYYY") : ""}</span>
                          </td>
                          <td className="width-10px"></td>
                        </tr>
                      ))
                    ) : (
                      <tr> <td colSpan={8} className="table-nodata">{upcomingtrainingList && "No record found"}</td> </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className={` ${isMobile ? "ml-68" : "ml-30"} mr-40 mt-3 table-responsive table-responsive-scroll common-bottom-developplan`}>
            <div className="border-left tablestyle-plan1 w-100 border-right ">
              <div className={`px-4 ml-0 pb-20 text-20-bold pt-4 position-relative row w-100  border-top`}>
                <div className="mt-3px pr-10 pl-10 col-6"><CommonIcon fileName="developmentplan" /><span className="pl-10">My development plan</span></div>
                <div className="text-16-red mt-3px col-6 text-align-end" onClick={() => { this.setState({ isDevelopmentPlan: true }) }}><span className="pr-10 cursor-pointer">Capability chart</span><CommonIcon fileName="forwardicon" /></div>
              </div>
              <div className={`table-fixed-header ${supportingRolesList?.length > 4 ? "height-33vh" : "h-auto"}`}>
                <table className="table traningtable">
                  <thead>
                    <tr>
                      <td className="border-bottom-none"></td>
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable1("jobGroup")}>
                        <span> Job group </span>
                        {developmentsortBy === "jobGroup" && (<CommonIcon fileName={developmentorder === "asc" ? "upArrow" : "downArrow"} />)}
                      </td>
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable1("jobName")}>
                        <span> Job/Task </span>
                        {developmentsortBy === "jobName" && (<CommonIcon fileName={developmentorder === "asc" ? "upArrow" : "downArrow"} />)}
                      </td>
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable1("skillName")}>
                        <span> Skills </span>
                        {developmentsortBy === "skillName" && (<CommonIcon fileName={developmentorder === "asc" ? "upArrow" : "downArrow"} />)}
                      </td>
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable1("levelName")}>
                        <span> Level </span>
                        {developmentsortBy === "levelName" && (<CommonIcon fileName={developmentorder === "asc" ? "upArrow" : "downArrow"} />)}
                      </td>
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable1("expectedProficiency")}>
                        <span> Proficiency expected </span>
                        {developmentsortBy === "expectedProficiency" && (<CommonIcon fileName={developmentorder === "asc" ? "upArrow" : "downArrow"} />)}
                      </td>
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable1("proficiency")}>
                        <span> Proficiency </span>
                        {developmentsortBy === "proficiency" && (<CommonIcon fileName={developmentorder === "asc" ? "upArrow" : "downArrow"} />)}
                      </td>
                      <td className="cursor-pointer border-bottom-none" onClick={() => this.sortTable1("mastery")}>
                        <span> Outstanding </span>
                        {developmentsortBy === "mastery" && (<CommonIcon fileName={developmentorder === "asc" ? "upArrow" : "downArrow"} />)}
                      </td>
                      <td className="width-10px border-bottom-none"></td>
                    </tr>
                  </thead>
                  <tbody>
                    {supportingRolesList.length !== 0 ? (
                      supportingRolesList.map((item, index) => (
                        <tr id={"active" + item?.skillJobManagementId} key={index} className={`${index === supportingRolesList.length - 1 ? "border-bottom" : ""}`}>
                          <td className="cursor-default"></td>
                          <td className="cursor-default width-150px">
                            <span className="">{item.jobGroup ? item.jobGroup : "-"}</span>
                          </td>
                          <td className="cursor-default width-150px">
                            <span className="">{item.jobName ? item.jobName : "-"}</span>
                          </td>
                          <td className="cursor-default width-150px">
                            <span className="">{item.skillName ? item.skillName : "-"}</span>
                          </td>
                          <td className="cursor-default width-150px">
                            <span className="">{item.levelName ? item.levelName : "-"}</span>
                          </td>
                          <td className="cursor-default text-wrap">
                            <span className="">{item.expectedProficiency ? item.expectedProficiency : "-"}</span>
                          </td>
                          <td className="text-wrap">
                            <span className={`fw-600  ${item.proficiency == "Competent" ? "blue-color" : item.proficiency == "Master" ? "green-color" : item.proficiency == "Learner" ? "orange-color" :
                              item.proficiency == "Novice" ? "yellow-color" : "brown-color"} cursor-default `}>
                              {item.proficiency ? item.proficiency : "NA"}
                            </span>
                          </td>
                          <td className="cursor-default">
                            {item.mastery >= 1 && (
                              <CommonIcon fileName="staricon" />
                            )}
                            {item.mastery >= 2 && (
                              <span className="mx-1"><CommonIcon fileName="staricon" /></span>
                            )}
                            {item.mastery >= 3 && (
                              <CommonIcon fileName="staricon" />
                            )}
                          </td>
                          <td className="width-10px"></td>
                        </tr>
                      ))
                    ) : (
                      <tr> <td colSpan={8} className="table-nodata">{supportingRolesList && "No record found"}</td> </tr>
                    )}
                  </tbody>
                </table>
              </div>

            </div>
          </div>

          <div className={`offcanvas offcanvas-end offcanvaspendingStyle mt-48`} tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="applyfortraining" aria-labelledby="offcanvasScrollingLabel">
            <div className={`offcanvas-header  heading-color px-4 pt-4  ${isMobile ? "pb-2" : "pb-3"}`}>
              <label>Training details
              </label>
              <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`} onClick={() => this.closeProperties()}>
                <CommonIcon fileName="CrossIcon" className="cursor-pointer app-image-hover" />
              </button>
            </div>
            <div className="offcanvas-body px-4 pt-2" >
              <div className="row gy-3">
                <div className={`${isMobile450 ? "col-12" : "col-6"}`}>
                  <div className="text-12-bold form-group">
                    <label className="mt-1px d-flex">
                      <CommonIcon fileName="CourseCodeIcon" className="properties-img" />
                      <span className="pl-5 properties-span-2">Course code</span>
                    </label>
                  </div>
                  <div className="text-12-normal-400 mt-2">{this.state.viewTrainingDetails.courseCode ? this.state.viewTrainingDetails.courseCode : " - "}</div>
                </div>

                <div className={`${isMobile450 ? "col-12" : "col-6"}`}>
                  <div className="text-12-bold form-group">
                    <label className="mt-1px d-flex"><CommonIcon fileName="CourseTitleIcon" />
                      <span className="pl-5 properties-span-2">Course title</span></label>
                  </div>
                  <div className="text-12-normal-400 mt-2">{this.state.viewTrainingDetails.courseTitle ? this.state.viewTrainingDetails.courseTitle : " - "}</div>
                </div>

                <div className={`${isMobile450 ? "col-12" : "col-6"}`}>
                  <div className="text-12-bold from-group">
                    <label className="mt-1px d-flex"><CommonIcon fileName="VendorNameIcon" />
                      <span className="pl-5 properties-span-2">Vendor</span></label>
                  </div>
                  <div className="text-12-normal-400 mt-2">{this.state.viewTrainingDetails.vendorName ? this.state.viewTrainingDetails.vendorName : " - "}</div>
                </div>
                {(UserRole.ADMIN == this.state.currentUser || UserRole.MANAGER == this.state.currentUser || UserRole.SUPERVISOR == this.state.currentUser) &&
                  <>
                    <div className={`${isMobile450 ? "col-12" : "col-6"}`}>
                      <div className="text-12-bold from-group">
                        <label className="mt-1px d-flex"><CommonIcon fileName="skillIcon" />
                          <span className="pl-5 properties-span-2">  Skills</span></label>
                      </div>
                      <div className="text-12-normal-400 mt-2">{this.state.viewTrainingDetails.skills ? this.state.viewTrainingDetails.skills : " - "}</div>
                    </div>
                  </>
                }
                <div className={`${isMobile450 ? "col-12" : "col-6"}`}>
                  <div className="text-12-bold from-group">
                    <label className="mt-1px d-flex"><CommonIcon fileName="traininghours" />
                      <span className="pl-5 properties-span-2"> Training hours</span></label>
                  </div>
                  <div className="text-12-normal-400 mt-2">{this.state.viewTrainingDetails.trainingHours ? this.state.viewTrainingDetails.trainingHours : " - "}</div>
                </div>

                <div className={`${isMobile450 ? "col-12" : "col-6"}`}>
                  <div className="text-12-bold from-group">
                    <label className="mt-1px d-flex"><CommonIcon fileName="DateIcon" />
                      <span className="pl-5 properties-span-2"> Start date </span></label>
                  </div>
                  <div className="text-12-normal-400 mt-2">{this.state.viewTrainingDetails.startDate ? moment(new Date(Date.parse(this.state.viewTrainingDetails.startDate))).format("DD-MMM-YYYY") : " - "}</div>
                </div>
                <div className={`${isMobile450 ? "col-12" : "col-6"}`}>
                  <div className="text-12-bold from-group">
                    <label className="mt-1px d-flex"><CommonIcon fileName="DateIcon" />
                      <span className="pl-5 properties-span-2"> End date</span></label>
                  </div>
                  <div className="text-12-normal-400 mt-2">{this.state.viewTrainingDetails.endDate ? moment(new Date(Date.parse(this.state.viewTrainingDetails.endDate))).format("DD-MMM-YYYY") : " - "}</div>
                </div>
                <div className="col-12">
                  <div className="text-12-bold from-group">
                    <label className="mt-1px d-flex"><CommonIcon fileName="description" />
                      <span className="pl-5 properties-span-2">Course description </span></label>
                  </div>
                  <div className="text-12-normal-400 mt-2">{this.state.viewTrainingDetails.courseDiscription ? this.state.viewTrainingDetails.courseDiscription : " - "}</div>
                </div>
                <div className="col-12">
                  <div className="text-12-bold from-group">
                    <label className="mt-1px d-flex"><CommonIcon fileName="description" />
                      <span className=" pl-5px pb-1">Training description</span></label>
                  </div>
                  <div className="text-12-normal-400 mt-2">{this.state.viewTrainingDetails.trainingDiscription ? this.state.viewTrainingDetails.trainingDiscription : " - "}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <CommonFilterModal
            closeSearch={() => this.closeSearch()}
        /> */}
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(home);
